require('./bootstrap');
require('./conditional');
require('nestable2');
import Swal from 'sweetalert2';
import i18next from 'i18next';
import Sortable from 'sortablejs';
import Chart from 'chart.js';
import colorpicker from 'bootstrap-colorpicker'

const default_lang = document.documentElement.lang.substr(0, 2);

const i18n = i18next.createInstance({
    lng: default_lang,
    fallbackLng: default_lang,
    nsSeparator: '.'
}, (err, t) => {

});
$.each(vuei18nLocales, function (lng, locale) {
    $.each(locale, function (key, trans) {
        i18n.addResources(lng, key, trans);
    });
});
window.locale = i18n;
window.Swal = Swal;

const Quizier = function () {
    const sweetDelete = function () {
        $(".warning-delete").on("click", function (event) {
            event.preventDefault();
            Swal.fire({
                title: i18n.t('i18n.areYouSureToDelete'),
                text: i18n.t('i18n.canNotRecover'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: i18n.t('i18n.yesDeleteIt'),
                cancelButtonText: i18n.t('i18n.noCancel'),
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    if ($(this).hasClass('frm-submit')) {
                        $(this).parents('form:first').submit();
                    }
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire(
                        i18n.t('i18n.cancelled'),
                        i18n.t('i18n.operationCancelled'),
                        'error'
                    )
                }
            });
        });
    },
        checkAll = function () {
            const $check_all = $('.checkbox_all[type=checkbox]');
            if (!$check_all.length) {
                return;
            }

            $check_all.click(function () {
                $('input:checkbox').not(this).prop('checked', this.checked);
            });
        },
        sweetTrash = function () {
            $(".warning-trash").on("click", function (event) {
                event.preventDefault();
                Swal.fire({
                    title: i18n.t('i18n.areYouSure'),
                    text: i18n.t('i18n.sendItemToTrash'),
                    icon: "info",
                    showCancelButton: true,
                    confirmButtonText: i18n.t('i18n.yesTrashIt'),
                    cancelButtonText: i18n.t('i18n.noCancel'),
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        if ($(this).hasClass('frm-submit')) {
                            $(this).parents('form:first').submit();
                        }
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.fire(
                            i18n.t('i18n.cancelled'),
                            i18n.t('i18n.operationCancelled'),
                            'error'
                        )
                    }
                });
            });
        },
        initSlug = function () {
            $(document).on("keyup change", '.slug_title', function () {
                var title = $(this).val();
                var titleUrlString = Quizier.convertToSlug(title);
                $(this).parent().parent().parent().find('.slug').val(titleUrlString);
            });
        },
        noAutoCloseDropdown = function () {
            $(document).on('click', '.options-panel .dropdown-menu', function (e) {
                e.stopPropagation();
            });
        },
        initSocialStream = function () {
            const elems = document.querySelectorAll('.initSocial');
            const $elems = [].slice.call(elems);
            $elems.map((elem) => {
                if (elem.childNodes.length != 0) {
                    if (typeof FB !== 'undefined') {
                        FB.XFBML.parse(elem);
                        elem.classList.remove("initSocial");
                    }
                    if (typeof twttr !== 'undefined') {
                        twttr.widgets.load(elem);
                        elem.classList.remove("initSocial");
                    }
                }
            });

            if (typeof instgrm !== 'undefined') {
                instgrm.Embeds.process();
            }
        },
        resizeiFrame = function () {
            const $allVideos = $("iframe[src*='//player.vimeo.com'], iframe[src*='//www.youtube.com']"),
                $fluidEl = $("#app-modules");
            $allVideos.each(function () {
                let ratio = this.height / this.width
                $(this).attr('data-aspectRatio', ratio)
                if (ratio > 0) {
                    $(this).removeAttr('height').removeAttr('width');
                }
            });
            $(window).resize(function () {
                var newWidth = $fluidEl.width();
                $allVideos.each(function () {
                    var $el = $(this);
                    $el.width(newWidth).height(newWidth * $el.attr('data-aspectRatio'));
                });
            }).resize();
        },
        loading = function ($event) {
            $event.addClass('d-none').next().removeClass('d-none');
        },
        stopLoading = function ($event) {
            $event.removeClass('d-none').next().addClass('d-none');
        },
        colorPicker = function () {
            $('.colorPicker')
                .colorpicker({})
                .on('colorpickerChange colorpickerCreate', function (event) {
                    $(this).find('.form-control').css('background-color', event.color.toString());
                });
        },
        dependantElements = function () {
            $(document).on('click', '.has-children', function () {
                let $child = $(this).data('child');
                $('.' + $child).toggle();
            })
        },
        requestAjax = function () {
            if ($('.requestAjax').length) {
                $(document).on('click', '.requestAjax', function (e) {
                    e.preventDefault();
                    let $url = $(this).data('url');
                    if ($url) {
                        let $this = $(this);
                        $('.requestAjax').attr("disabled", true);
                        $this.find('.spinner-border').removeClass('d-none');

                        axios.get($url)
                            .then(function (response) {
                                if (response.data.success) {
                                    Quizier.sweetSuccess(response.data.message);
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                            }).then(function () {
                                $('.requestAjax').attr("disabled", false);
                                $this.find('.spinner-border').addClass('d-none');
                            });;
                    }
                })
            }
        },
        settingsForm = function () {
            $(document).on('click', '#settings-btn', function () {
                $(':required:invalid').each(function () {
                    var id = $('.tab-pane').find(':required:invalid').closest('.tab-parent').attr('id');
                    var id2 = $('.tab-pane').find(':required:invalid').closest('.tab-pane').attr('id');
                    $('.nav a[href="#' + id + '"], .nav a[href="#' + id2 + '"]').tab('show');

                    $(this).focus();
                });
            });
        },
        sidebarMinimizer = function () {
            $('.sidebar-minimizer').on('click', function (e) {
                e.preventDefault();
                if (Boolean(localStorage.getItem('sidebar-toggle-expanded'))) {
                    localStorage.setItem('sidebar-toggle-expanded', '');
                } else {
                    localStorage.setItem('sidebar-toggle-expanded', '1');
                }
            });

            if (localStorage.getItem("sidebar-toggle-expanded") !== null) {
                if (localStorage.getItem("sidebar-toggle-expanded") === '1') {
                    $("body").addClass('sidebar-minimized brand-minimized');
                }
            }
        };
    return {
        init: function () {
            sweetDelete();
            sweetTrash();
            initSlug();
            noAutoCloseDropdown();
            checkAll();
            dependantElements();
            colorPicker();
            requestAjax();
            settingsForm();
            // sidebarMinimizer();
            this.postChart();
            $('body').tooltip({
                selector: '[data-toggle="tooltip"]'
            });

        },
        initWidgets: function ($addUrl, $sortUrl) {
            this.selectWidget();
            this.deleteWidget();
            if ($addUrl) {
                this.addWidget($addUrl);
            }
            if ($sortUrl) {
                this.sortWidgets($sortUrl);
            }
            this.saveWidget();
        },
        convertToSlug: function (string) {
            const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįıłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
            const b = 'aaaaaaaaacccddeeeeeeegghiiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
            const p = new RegExp(a.split('').join('|'), 'g')

            return string.toString().toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                .replace(/&/g, '-and-') // Replace & with 'and'
                .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                .replace(/\-\-+/g, '-') // Replace multiple - with single -
                .replace(/^-+/, '') // Trim - from start of text
                .replace(/-+$/, '') // Trim - from end of text
        },
        sortWidgets: function ($sortUrl) {
            $('.sortable-widgets-wrapper').each(function (i, obj) {
                let el = document.getElementById(obj.id);
                new Sortable(el, {
                    animation: 150,
                    handle: '.card .card-header',
                    ghostClass: 'ghost-class',
                    onSort: function (e) {
                        let items = e.to.children;
                        let orders = [];
                        for (var i = 0; i < items.length; i++) {
                            orders.push($(items[i]).data('id'));
                        }
                        axios.post($sortUrl, {
                            ids: orders
                        })
                            .then((response) => {
                                if (!response.data.success) {
                                    Quizier.sweetError(response.data.response.message);
                                    return;
                                }
                            }, (error) => {
                                if (error.response.data.message) {
                                    Quizier.sweetError(error.response.data.message);
                                } else
                                    Quizier.sweetError(error);
                            });
                    }
                });
            });
        },
        selectWidget: function () {
            $(document).on('click', '.widgetSelection', function (e) {
                e.preventDefault();
                const $parent = $(this).parent();
                $parent.find('.nav-link').removeClass('active');
                $(this).addClass('active');
                $parent.parent().next().removeClass('d-none');
            });
        },
        saveWidget: function () {
            $(document).on('click', '.saveWidget', function (e) {
                e.preventDefault();
                const $this = $(this);
                const $frmID = $this.data('id');
                const $frm = $($frmID);
                const $saveWidget = $frm.attr('action');
                if ($saveWidget) {
                    loading($this)
                    const $data = $($frm).serialize()
                    axios.put($saveWidget, $data)
                        .then((response) => {
                            stopLoading($this)
                            if (!response.data.success) {
                                Quizier.sweetError(response.data.response.message);
                                return;
                            }
                        }, (error) => {
                            stopLoading($this)
                            if (error.response.data.message) {
                                Quizier.sweetError(error.response.data.message);
                            } else
                                Quizier.sweetError(error);
                        });
                }
            });
        },
        deleteWidget: function () {
            $(document).on('click', '.deleteWidget', function (e) {
                e.preventDefault();
                const $this = $(this);
                const $parent = $this.parent();
                const $deleteWidget = $parent.attr('action');
                if ($deleteWidget) {
                    const $data = $this.data();
                    loading($this);
                    axios.delete($deleteWidget, $data)
                        .then((response) => {
                            stopLoading($this);
                            if (!response.data.success) {
                                Quizier.sweetError(response.data.response.message);
                                return;
                            }
                            $('#widget-' + $this.data('id')).remove()
                        }, (error) => {
                            stopLoading($this);
                            if (error.response.data.message) {
                                Quizier.sweetError(error.response.data.message);
                            } else
                                Quizier.sweetError(error);
                        });
                }
            });
        },
        addWidget: function ($addWidget) {
            $(document).on('click', '.addWidget', function (e) {
                e.preventDefault();
                const $this = $(this)
                const $parent = $this.parent();
                const $nav = $parent.prev().find('.nav-link.active');
                if ($nav.length) {
                    const $data = $nav.data();
                    loading($this);
                    axios.post($addWidget, $data)
                        .then((response) => {
                            stopLoading($this);
                            if (!response.data.success) {
                                Quizier.sweetError(response.data.response.message);
                                return;
                            }

                            $(response.data.widget).append(response.data.response.html)
                            $(response.data.toggle).collapse('show');
                        }, (error) => {
                            stopLoading($this);
                            if (error.response.data.message) {
                                Quizier.sweetError(error.response.data.message);
                            } else
                                Quizier.sweetError(error);
                        });
                }
            });
        },
        initSocial: function () {
            initSocialStream();
            resizeiFrame()
        },
        sweetError: function (text, callback, options) {
            const defaults = {
                icon: 'error',
                title: i18n.t('i18n.error'),
                text: text,
                confirmButtonText: i18n.t('i18n.ok'),
                allowOutsideClick: false,
                allowEscapeKey: false
            };
            $.extend(true, defaults, options || {});
            Swal.fire(defaults).then(function (result) {
                $.isFunction(callback) && callback();
            });
        },
        sweetErrors: function (html, callback, options) {
            const defaults = {
                icon: 'error',
                title: i18n.t('i18n.error'),
                html: html,
                confirmButtonText: i18n.t('i18n.ok'),
                allowOutsideClick: false,
                allowEscapeKey: false
            };
            $.extend(true, defaults, options || {});
            Swal.fire(defaults).then(function (result) {
                $.isFunction(callback) && callback();
            });
        },
        sweetInfo: function (text, callback, options) {
            const defaults = {
                icon: 'info',
                title: i18n.t('i18n.information'),
                text: text,
                confirmButtonText: i18n.t('i18n.ok'),
                allowOutsideClick: false,
                allowEscapeKey: false,
            };
            $.extend(true, defaults, options || {});
            Swal.fire(defaults).then(function (result) {
                $.isFunction(callback) && callback();
            });
        },
        sweetSuccess: function (text, callback, options) {
            const defaults = {
                icon: 'success',
                title: i18n.t('i18n.success'),
                text: text,
                timer: 2000,
                confirmButtonText: i18n.t('i18n.ok'),
                allowOutsideClick: false,
                allowEscapeKey: false,
            };
            $.extend(true, defaults, options || {});
            Swal.fire(defaults).then(function (result) {
                $.isFunction(callback) && callback();
            });
        },
        sweetPrompt: function (text, callback, options) {
            const defaults = {
                title: text,
                input: 'text',
                confirmButtonText: i18n.t('i18n.ok'),
                showCancelButton: true,
                cancelButtonText: i18n.t('i18n.cancel'),
                allowOutsideClick: false,
                allowEscapeKey: false,
                inputValidator: function (value) {
                    if (!value) {
                        return i18n.t('i18n.valueIsRequired');
                    }
                }
            };
            $.extend(true, defaults, options || {});
            Swal.fire(defaults).then(function (result) {
                if (result.value) {
                    $.isFunction(callback) && callback(result);
                }
            });
        },
        postChart: function () {
            if (typeof window.graphData !== 'undefined') {
                let cdata = window.graphData
                var mainChart = new Chart($('#main-chart'), {
                    type: 'line',
                    data: {
                        labels: cdata.labels,
                        datasets: [{
                            label: i18n.t('i18n.posts'),
                            backgroundColor: hexToRgba(getStyle('--info'), 10),
                            borderColor: getStyle('--info'),
                            pointHoverBackgroundColor: '#fff',
                            borderWidth: 2,
                            data: cdata.posts
                        }, {
                            label: i18n.t('i18n.users'),
                            backgroundColor: 'transparent',
                            borderColor: getStyle('--success'),
                            pointHoverBackgroundColor: '#fff',
                            borderWidth: 2,
                            data: cdata.users
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    drawOnChartArea: false
                                }
                            }],
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    maxTicksLimit: 5,
                                }
                            }]
                        },
                        elements: {
                            point: {
                                radius: 0,
                                hitRadius: 10,
                                hoverRadius: 4,
                                hoverBorderWidth: 3
                            }
                        }
                    }
                });
            }
        },

    }
}();

window.Quizier = Quizier;
$(function () {
    Quizier.init();

    $.ajaxSetup({
        cache: true
    });

    $.getScript('//assets.pinterest.com/js/pinit_main.js');
    $.getScript('//embed.redditmedia.com/widgets/platform.js');
    $.getScript('//embedr.flickr.com/assets/client-code.js');
    $.getScript('//www.instagram.com/embed.js');
    $.getScript('//platform.twitter.com/widgets.js');
    $.getScript('//connect.facebook.net/en_US/sdk.js', function () {
        if (window.fb_app_id) {
            FB.init({
                appId: fb_app_id,
                status: true,
                cookie: true,
                version: 'v6.0'
            });
        }

        Quizier.initSocial();
    });
});
